import { render, staticRenderFns } from "./Dropshippers.vue?vue&type=template&id=32bd8ddb&scoped=true"
import script from "./Dropshippers.vue?vue&type=script&lang=js"
export * from "./Dropshippers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32bd8ddb",
  null
  
)

export default component.exports